import * as React from "react";
import MobileNavigationSelector, {
  ItemsCaretPosition,
} from "../mobile-navigation-selector/MobileNavigationSelector";
import translate from "/src/utils/translate";
import AccountIcon from "/src/svg/account.svg";
import LinkTag from "../../buttons/link-tag/LinkTag";
import {css} from "/src/utils/utils";
import {LOCALE} from "/src/config";

import * as styles from "./mobile-sign-in-selector.module.scss";
import Icon from "../../icon/Icon";

interface SignInOption {
  label: string;
  url: string;
}

const SignInOptions: Array<SignInOption> = [
  {
    label: translate("Forwarding"),
    url: "https://app.flexport.com/users/sign_in",
  },
  {
    label: translate("Fulfillment"),
    url: "https://login.portal.flexport.com/",
  },
];

interface Props {
  disabled: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export default function MobileSignInSelector(props: Props) {
  const {disabled, onClose, onOpen} = props;

  if (LOCALE !== "en-US") {
    return (
      <div className={styles.mobileSignInSelector__linkWrapper}>
        <LinkTag
          href="https://app.flexport.com"
          openInNewTab
          classes={styles.mobileSignInSelector__linkWrapper__link}
        >
          <Icon
            svg={AccountIcon}
            role="presentation"
            classes={styles.mobileSignInSelector__linkWrapper__icon}
          />
          {translate("Sign In")}
        </LinkTag>
      </div>
    );
  }

  return (
    <MobileNavigationSelector
      disabled={disabled}
      label={translate("Sign In")}
      numberOfItems={SignInOptions.length}
      onClose={onClose}
      onOpen={onOpen}
      itemsCaretPosition={ItemsCaretPosition.LEFT}
      leftIconSvg={AccountIcon}
    >
      {focusedListItem => {
        return SignInOptions.map(({label, url}, index) => (
          <LinkTag
            key={`${label}`}
            classes={css(
              styles.mobileSignInSelector__item,
              index === focusedListItem
                ? styles.mobileSignInSelector__itemFocus
                : ""
            )}
            href={url}
            openInNewTab
            role="option"
            aria-label={label}
          >
            {label}
          </LinkTag>
        ));
      }}
    </MobileNavigationSelector>
  );
}
